/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import { Paper, Typography } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

interface Props {
  lossHistory: number[];
  title?: string;
}

export default function LossChart({ lossHistory, title = 'Training Loss' }: Props) {
  const chartData = lossHistory.map((loss, i) => ({
    epoch: i + 1,
    loss,
  }));

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        {title}
      </Typography>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={chartData} margin={{ top: 5, right: 20, bottom: 25, left: 10 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="epoch"
            type="number"
            domain={['dataMin', 'dataMax']}
            label={{ value: 'Epoch', position: 'bottom', offset: 10 }}
          />
          <YAxis label={{ value: 'Loss', angle: -90, position: 'insideLeft' }} />
          <Tooltip />
          <Line type="monotone" dataKey="loss" stroke="#f44336" dot={false} strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </Paper>
  );
}
